import { Link } from "react-router-dom";
import logo from "@/assets/wolf-cto-logo.png";
import { CASE_STUDIES } from "@/lib/case-studies";

const truncateWords = (text: string, max: number) => {
  const words = text.split(/\s+/);
  return words.length <= max ? text : words.slice(0, max).join(" ");
};

const Footer = () => {
  return (
    <footer className="bg-primary py-16">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <img
              src={logo}
              alt="Wolf CTO"
              width={480}
              height={198}
              className="h-10 w-auto brightness-0 invert mb-4"
            />
            <p className="text-primary-foreground/60 text-sm leading-relaxed">
              AI systems that cut costs and lift revenue. Built for $5M+
              businesses.
            </p>
          </div>

          {/* Case Studies Column */}
          <div>
            <h4 className="text-primary-foreground font-semibold text-sm uppercase tracking-wider mb-4">
              Case Studies
            </h4>
            <ul className="space-y-3">
              {CASE_STUDIES.map((study) => (
                <li key={study.slug}>
                  <Link
                    to={study.href}
                    className="text-primary-foreground/60 hover:text-gold text-sm transition-colors">
                    {truncateWords(
                      `${study.title.lead} ${study.title.accent}`,
                      6,
                    )}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/case-study"
                  className="text-primary-foreground/60 hover:text-gold text-sm transition-colors">
                  View All Case Studies
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-primary-foreground font-semibold text-sm uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/get-started"
                  className="text-primary-foreground/60 hover:text-gold text-sm transition-colors">
                  Get Started
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-primary-foreground/60 hover:text-gold text-sm transition-colors">
                  About
                </Link>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/paul-chiappetta/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-foreground/60 hover:text-gold text-sm transition-colors">
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://wolfcto.substack.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-foreground/60 hover:text-gold text-sm transition-colors">
                  Substack
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-primary-foreground/40 text-sm">
            &copy; {new Date().getFullYear()} Wolf CTO. All rights reserved.
          </p>
          <p className="text-primary-foreground/40 text-sm">
            AI Operations &middot; Built for $5M+ businesses
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
